export const ReportSemanalIcon = ({ width = 112, height = 156 }) => (
  <svg
    id="Layer_1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    width={width}
    height={height}
  >
    <path
      d="m21.937 4.716c-.104-.276-.323-.492-.602-.591-.129-.046-3.232-1.125-9.335-1.125s-9.206 1.079-9.335 1.125c-.278.099-.498.315-.602.591-.043.116-1.063 2.887-1.063 7.284s1.02 7.168 1.063 7.284c.104.276.324.492.602.591.129.046 3.232 1.125 9.335 1.125s9.206-1.079 9.335-1.125c.278-.099.498-.315.602-.591.043-.116 1.063-2.887 1.063-7.284s-1.021-7.168-1.063-7.284zm-13.437 11.784c-3.214 0-4.5-1.286-4.5-4.5 0-2.854 1.022-4.182 3.5-4.445v4.445c0 .265.105.52.293.707.071.072 1.514 1.479 4.037 2.843-.725.648-1.804.95-3.33.95zm4.3-2.693c-1.653-.893-2.795-1.807-3.3-2.247v-4.005c2.478.263 3.5 1.591 3.5 4.445 0 .696-.073 1.285-.2 1.807zm6.2 3.193h-3c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1zm0-4h-3c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1zm0-4h-3c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1z"
      fill="#525252"
    />
  </svg>
);
